export const contacts = [
  {
    id: '0708a358-3077-4825-e600-1ce18f4c1c47',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '644-27-9243',
    name: 'Kendra Rodriguez',
    type: 'home',
    fein_tax: '',
    position: 'Financial risk analyst',
    primary_address: {
      id: '333535a1-40c9-1566-683f-30f702a9785a',
      type: 'home',
      line1: '01455 Kyle Expressway',
      line2: '9658 Kevin Throughway',
      city: 'Edwardsmouth',
      county: '',
      country: 'Ireland',
      state: 'AR',
      zip: '48781',
      full_address: 'Edwardsmouth, AR, 48781'
    },
    addresses: [],
    primary_phone: {
      id: '9e9c1e9a-1a62-3916-39c6-67396c351424',
      type: 'home',
      phone: '555 002 1344'
    },
    phones: [],
    primary_email: {
      id: '1727845c-a426-c06f-752b-490cf100fb6e',
      type: 'home',
      email: 'conradgrace@logan.com'
    },
    emails: []
  },
  {
    id: 'e789610b-d911-5b0b-3871-33d02d1aeac8',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '605-95-0504',
    name: 'Richard Whitney',
    type: 'home',
    fein_tax: '',
    position: 'Health visitor',
    primary_address: {
      id: '1ddb077c-aa8c-8c0d-b5fc-ec93c1f8d2a9',
      type: 'home',
      line1: '1530 Wilson Flat',
      line2: '7560 Jackson Turnpike',
      city: 'North Melissa',
      county: '',
      country: 'Mayotte',
      state: 'TN',
      zip: '89223',
      full_address: 'North Melissa, TN, 89223'
    },
    addresses: [],
    primary_phone: {
      id: 'b5d2a8bb-72af-bceb-0228-9a5dce0b00ce',
      type: 'home',
      phone: '555 006 1344'
    },
    phones: [],
    primary_email: {
      id: 'cc77dbba-412a-7d5f-d8d6-b2148bc5f5f2',
      type: 'home',
      email: 'richard21@scott-taylor.org'
    },
    emails: []
  },
  {
    id: 'bd713307-d3d7-d111-36e4-3270669165c7',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '872-65-7683',
    name: 'Cheryl Hartman',
    type: 'home',
    fein_tax: '',
    position: 'Trade union research officer',
    primary_address: {
      id: 'a36c5ebb-eb30-fb14-fc5c-e85b36d5abeb',
      type: 'home',
      line1: '3930 Cummings Fields',
      line2: '66231 King Expressway Apt. 205',
      city: 'East Marcus',
      county: '',
      country: 'Czech Republic',
      state: 'ND',
      zip: '46720',
      full_address: 'East Marcus, ND, 46720'
    },
    addresses: [],
    primary_phone: {
      id: 'a5ececb9-cbdc-2f50-80cc-a6e71e12150c',
      type: 'home',
      phone: '555 010 1344'
    },
    phones: [],
    primary_email: {
      id: '9f5b1efd-2c35-58ee-c004-55c076b9edcf',
      type: 'home',
      email: 'charlottesmith@dalton.com'
    },
    emails: []
  },
  {
    id: '71989560-1fe0-17c3-99a4-7343b6eb7c3f',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '880-62-7187',
    name: 'Charles Spence',
    type: 'home',
    fein_tax: '',
    position: 'Scientist, forensic',
    primary_address: {
      id: 'ce56fc01-bdee-5e38-15ce-d27278d23823',
      type: 'home',
      line1: '5351 Christopher Knoll',
      line2: '3741 Martin Cape Suite 808',
      city: 'Williamshaven',
      county: '',
      country: 'Ireland',
      state: 'PA',
      zip: '61294',
      full_address: 'Williamshaven, PA, 61294'
    },
    addresses: [],
    primary_phone: {
      id: '2dfc7236-69c0-a257-d0e3-bc2602a21834',
      type: 'home',
      phone: '555 014 1344'
    },
    phones: [],
    primary_email: {
      id: '089eb7fe-40e1-7c53-cf33-44c4989fa957',
      type: 'home',
      email: 'davisjames@edwards.org'
    },
    emails: []
  },
  {
    id: 'da4bc1cc-13de-c92b-8ee7-1dcf5894a309',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '533-46-1641',
    name: 'Robert Nelson',
    type: 'home',
    fein_tax: '',
    position: 'Passenger transport manager',
    primary_address: {
      id: '546127e1-38ba-780e-855d-47b7cfe262b6',
      type: 'home',
      line1: '300 Denise Park',
      line2: '15282 Adams Highway',
      city: 'Calderonville',
      county: '',
      country: 'Sierra Leone',
      state: 'RI',
      zip: '14314',
      full_address: 'Calderonville, RI, 14314'
    },
    addresses: [],
    primary_phone: {
      id: '0a1ce8a3-3b6f-bc1c-23c1-3735e6ece7da',
      type: 'home',
      phone: '555 018 1344'
    },
    phones: [],
    primary_email: {
      id: 'ffd5a590-c692-d946-afe2-eee0f26ecb20',
      type: 'home',
      email: 'michaelsnyder@gmail.com'
    },
    emails: []
  },
  {
    id: 'a8cced30-ee0a-9398-f918-7ed8786cee46',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '110-38-5735',
    name: 'Robert Brown',
    type: 'home',
    fein_tax: '',
    position: 'Merchant navy officer',
    primary_address: {
      id: 'e6a48d74-54a7-3ef0-6ae1-815fa8032964',
      type: 'home',
      line1: '91664 Reid Locks Suite 786',
      line2: '714 Torres Park',
      city: 'Katiefort',
      county: '',
      country: 'Kenya',
      state: 'TN',
      zip: '92973',
      full_address: 'Katiefort, TN, 92973'
    },
    addresses: [],
    primary_phone: {
      id: 'aaf62ea0-20b7-3f6b-741f-aa7b77a31358',
      type: 'home',
      phone: '555 022 1344'
    },
    phones: [],
    primary_email: {
      id: '75f369a5-7820-a9ff-f529-fe97e2343698',
      type: 'home',
      email: 'lanebarbara@phelps.com'
    },
    emails: []
  },
  {
    id: 'fe48f021-4298-d702-c7cc-221e7f1853b2',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '626-74-4140',
    name: 'Joshua Jones',
    type: 'home',
    fein_tax: '',
    position: 'Mudlogger',
    primary_address: {
      id: '25da5a34-73dc-3884-c489-bd2f00d547aa',
      type: 'home',
      line1: '646 Beltran Manors',
      line2: '94591 Christina Bypass Suite 338',
      city: 'Norriston',
      county: '',
      country: 'Estonia',
      state: 'CO',
      zip: '46191',
      full_address: 'Norriston, CO, 46191'
    },
    addresses: [],
    primary_phone: {
      id: 'b29bd004-f25f-4de2-29eb-95efe7e96c23',
      type: 'home',
      phone: '555 026 1344'
    },
    phones: [],
    primary_email: {
      id: '2c756029-aee1-2bf2-64a5-52d61e206326',
      type: 'home',
      email: 'natasha96@gmail.com'
    },
    emails: []
  },
  {
    id: '8e103a98-a0f4-b9a1-455b-f33868ab0d8f',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '803-04-0116',
    name: 'Thomas Yang',
    type: 'home',
    fein_tax: '',
    position: 'Brewing technologist',
    primary_address: {
      id: '4db88ff2-e487-ef24-21a6-69735bd1605a',
      type: 'home',
      line1: '190 Chang Skyway',
      line2: '465 Elizabeth Port',
      city: 'West Saraside',
      county: '',
      country: 'Saint Helena',
      state: 'MI',
      zip: '14635',
      full_address: 'West Saraside, MI, 14635'
    },
    addresses: [],
    primary_phone: {
      id: '834557d0-ce39-05d4-a7b3-d060e4f518dc',
      type: 'home',
      phone: '555 030 1344'
    },
    phones: [],
    primary_email: {
      id: '6804a2e4-1be6-4484-dbcd-6fd2f92db01d',
      type: 'home',
      email: 'rhuber@osborne.com'
    },
    emails: []
  },
  {
    id: '3e64909d-f7ad-b2ef-5e7e-fd35bf357627',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '370-07-8975',
    name: 'James Wilcox',
    type: 'home',
    fein_tax: '',
    position: 'Chartered legal executive (England and Wales)',
    primary_address: {
      id: '056d476d-1f76-12f1-4cc6-341f7c23cc4d',
      type: 'home',
      line1: '953 Johnson Mountains',
      line2: '16575 Thornton Corner Apt. 727',
      city: 'Lake Timothy',
      county: '',
      country: 'Iran',
      state: 'CO',
      zip: '44742',
      full_address: 'Lake Timothy, CO, 44742'
    },
    addresses: [],
    primary_phone: {
      id: 'dda92dd1-de4a-10bc-9fcd-00d3533c7f6a',
      type: 'home',
      phone: '555 034 1344'
    },
    phones: [],
    primary_email: {
      id: 'f825e233-b995-5999-3368-a191d44334ae',
      type: 'home',
      email: 'brianna11@gmail.com'
    },
    emails: []
  },
  {
    id: 'cd848c2c-5996-b6a2-42e0-c223268c2f46',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '096-72-7196',
    name: 'Philip Watkins',
    type: 'home',
    fein_tax: '',
    position: 'Oncologist',
    primary_address: {
      id: '04aee87a-1ef9-646c-7256-fceefee108dd',
      type: 'home',
      line1: '048 Morris Alley',
      line2: '05718 Wade Port Apt. 124',
      city: 'Jenniferburgh',
      county: '',
      country: 'Austria',
      state: 'GU',
      zip: '20262',
      full_address: 'Jenniferburgh, GU, 20262'
    },
    addresses: [],
    primary_phone: {
      id: 'f05536d4-d1a7-8574-eb5a-7cb8ec86b4c6',
      type: 'home',
      phone: '555 038 1344'
    },
    phones: [],
    primary_email: {
      id: '0172ccfa-f14c-025e-c0ea-125b1b45045f',
      type: 'home',
      email: 'gwilson@hayes.com'
    },
    emails: []
  },
  {
    id: '061ec31d-cc0a-308e-6ae5-e2c96ec5afb6',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '236-46-5594',
    name: 'Jennifer Howard',
    type: 'home',
    fein_tax: '',
    position: 'Counsellor',
    primary_address: {
      id: '645f6225-9071-de13-a3e4-b77d13f5b354',
      type: 'home',
      line1: '170 Jessica Underpass',
      line2: '75571 Cheryl Mill Suite 882',
      city: 'Thompsonmouth',
      county: '',
      country: 'Somalia',
      state: 'WI',
      zip: '99414',
      full_address: 'Thompsonmouth, WI, 99414'
    },
    addresses: [],
    primary_phone: {
      id: '743103e0-ee7a-2a7b-ab7d-d23329a0f2fc',
      type: 'home',
      phone: '555 042 1344'
    },
    phones: [],
    primary_email: {
      id: 'b51143b6-0cea-f2cc-b9c1-6c38fa5230c3',
      type: 'home',
      email: 'jameszimmerman@ramirez.biz'
    },
    emails: []
  },
  {
    id: 'bcef3797-2ab5-9970-597f-cabd8a37174a',
    dbs: '2016-12-31T01:39:20+0000',
    dob: '1990-12-31T01:39:20+0000',
    ssn: '615-88-5730',
    name: 'Cynthia Becker',
    type: 'home',
    fein_tax: '',
    position: 'Automotive engineer',
    primary_address: {
      id: '18d793b1-d2c9-7412-c111-06a37098d247',
      type: 'home',
      line1: '108 Jay Vista Suite 363',
      line2: '5975 Shaw Crossing Apt. 334',
      city: 'Lake Christopherstad',
      county: '',
      country: 'Russian Federation',
      state: 'MO',
      zip: '39001',
      full_address: 'Lake Christopherstad, MO, 39001'
    },
    addresses: [],
    primary_phone: {
      id: '8001a361-44dc-daa2-5da1-46065c7ab9d3',
      type: 'home',
      phone: '555 046 1344'
    },
    phones: [],
    primary_email: {
      id: '367dd4d8-f086-cb80-b53a-a29d12d24c15',
      type: 'home',
      email: 'cassidy21@gmail.com'
    },
    emails: []
  }
]
